import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-based-upon-the';

const validator = () => null;

const vFParams = {
  paragraph: 'Based upon the information provided, the earliest dates for your change are below. Please select your desired target date and note this date is subject to change.',
};

const paragraphBasedUponThe = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphBasedUponThe };
